export default function reportInstancesDirective() {
  return {
    template: require('./report-instances.html'),
    controller: 'MRReportInstancesController',
    controllerAs: 'mrReportInstancesVM',
    bindToController: true,
    replace: true,
    scope: {
      customerId: '@',
      reportInstances: '=',
    },
  };
}
